import LoadQueue = createjs.LoadQueue;
import Container = createjs.Container;
import { LoaderInfo } from "./LoaderInfo";
import { URLRequest } from "./URLRequest";

export class Loader extends Container {
    public urlRequest: URLRequest;
    public loadQueue: LoadQueue;

    constructor() {
        super();
    }

    public load(urlRequest: URLRequest): void {
        this.loadQueue.loadFile(this.urlRequest.url);
    }

    public get contentLoaderInfo(): LoaderInfo {
        return new LoaderInfo();
    }
}
